import { render, staticRenderFns } from "./UriWidget.vue?vue&type=template&id=3c7c1b7f&scoped=true&"
import script from "./UriWidget.vue?vue&type=script&lang=js&"
export * from "./UriWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7c1b7f",
  null
  
)

export default component.exports